export default {
	title: "Temas",
	darkMode: "Modo Escuro",
	orixas: {
		ori: "ORI",
		exu: "Exú",
		ogum: "Ogum",
		oxossi: "Oxóssi",
		xango: "Xangô",
		oxum: "Oxum",
		iemanja: "Iemanjá",
		oxala: "Oxalá",
		nana: "Nanã",
		iansa: "Iansã",
		ibeji: "Ibeji",
	},
	descriptions: {
		ori: "Tema padrão do sistema ORI",
		exu: "Guardião dos caminhos - Preto com Vermelho",
		ogum: "Orixá dos caminhos e da guerra - Vermelho",
		oxossi: "Orixá da caça e da fartura - Verde e Azul",
		xango: "Orixá da justiça e dos raios - Marrom e Branco",
		oxum: "Orixá dos rios e do amor - Azul Escuro",
		iemanja: "Rainha do mar - Azul e Branco",
		oxala: "Pai de todos os orixás - Branco puro",
		nana: "Orixá ancestre - Roxo e Lilás",
		iansa: "Senhora dos ventos e tempestades - Amarelo e Coral",
		ibeji: "Orixás gêmeos da alegria - Azul claro e Rosa",
	},
};
